// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 217) return "static/chunks/217-31b15a93dfecb014.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "18f6e408cb40d69d" + ".js";
};